import React, { useContext, useEffect, useRef, useState } from 'react'
import { isEmpty, get, map, has, uniqueId } from 'lodash'
import { MenuContextToggle, BookInfo } from '../../contexts/menuContext'
import { useHistory } from 'react-router-dom'

const ChapterMenuItem = ({ menuItem, type }) => {
  const predefinedPages = ['about-the-authors', 'acknowledgments', 'copyright-citation-book-information', 'disclaimer', 'summary']
  const [book, setBook, page, setPage, , setForceScroll] = useContext(BookInfo)
  const result = page ? JSON.stringify(menuItem).search(`"${page.replace('p_', '')}"`) : -1
  const [toggleMenu, setToggleMenu] = useContext(MenuContextToggle)
  const [menuStatus, changeMenuStatus] = useState(result > 0)
  const history = useHistory();
  const ref = useRef();
  useEffect(() => {
    if (menuStatus && !get(menuItem, 'children', false)) {
      if (ref.current.offsetTop !== 0) {
        document.querySelector('.tab-pane.active .chapter-menu > ul').scrollTop = ref.current.offsetTop - 300;
      }
    }
  }, [menuStatus])
  return (

    <li
      ref={ref}
      className={`menu-list-item  ${menuStatus && 'active-trail-menu'}`}
    >
      {!isEmpty(get(menuItem, 'children', false)) && <svg
        width="1em"
        height="1em"
        viewBox="0 0 16 16"
        className="bi bi-caret-left-fill"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.86 8.753l5.482 4.796c.646.566 1.658.106 1.658-.753V3.204a1 1 0 0 0-1.659-.753l-5.48 4.796a1 1 0 0 0 0 1.506z"
        />
      </svg>}

      <button
        onClick={() => {
          changeMenuStatus(!menuStatus)
          setToggleMenu(false)

          let pageId = get(menuItem, 'value.id', '')
          let children = get(menuItem, 'children', [])

          if (children.length === 0 && has(menuItem, 'value.id')) {
            setForceScroll(true)
            setPage(pageId)

            if (has(menuItem, 'value.url')) {
              history.push(get(menuItem, 'value.url'), {page_id: pageId, subsection_type: 'chapters'})
            }
            // Since we have a valid value id but no URL we are most likely in
            // the front matter. Set the URL to just the book.
            else if(has(book, 'url') && window.location.pathname !== get(book, 'url')) {
              history.push(get(book, 'url'));
            }
          }
        }}
        type="button"
        className={`btn btn-link menu-list-item-button ${isEmpty(get(menuItem, 'children', false)) && 'no-children'}`}
      >
        {(!!get(menuItem, 'flags.just_updated')) &&
        <svg
          version="1.1"
          viewBox="100 100 300 300"
          fill="#224d91"
        >
          <path d="M368,112c-11,1.4-24.9,3.5-39.7,3.5c-23.1,0-44-5.7-65.2-10.2c-21.5-4.6-43.7-9.3-67.2-9.3c-46.9,0-62.8,10.1-64.4,11.2   l-3.4,2.4v2.6v161.7V416h16V272.7c6-2.5,21.8-6.9,51.9-6.9c21.8,0,42.2,8.3,63.9,13c22,4.7,44.8,9.6,69.5,9.6   c14.7,0,27.7-2,38.7-3.3c6-0.7,11.3-1.4,16-2.2V126v-16.5C379.4,110.4,374,111.2,368,112z"/>
        </svg>}
        {(!!get(menuItem, 'flags.significant_law_change')) &&
        <svg
          version="1.1"
          viewBox="100 100 300 300"
          fill="#c8102e"
        >
          <path d="M368,112c-11,1.4-24.9,3.5-39.7,3.5c-23.1,0-44-5.7-65.2-10.2c-21.5-4.6-43.7-9.3-67.2-9.3c-46.9,0-62.8,10.1-64.4,11.2   l-3.4,2.4v2.6v161.7V416h16V272.7c6-2.5,21.8-6.9,51.9-6.9c21.8,0,42.2,8.3,63.9,13c22,4.7,44.8,9.6,69.5,9.6   c14.7,0,27.7-2,38.7-3.3c6-0.7,11.3-1.4,16-2.2V126v-16.5C379.4,110.4,374,111.2,368,112z"/>
        </svg>}
        {get(menuItem, 'title', false) ? menuItem.title : menuItem.value.title}
      </button>
      {!isEmpty(get(menuItem, 'children', [])) && (menuStatus || toggleMenu) &&
      <ChapterMenu
        menuItems={menuItem?.children}
        toggleMenu={toggleMenu}
        type={type}
      />}
    </li>
  )
}

const ChapterMenu = ({ menuItems, toggleMenu, level = 1, type }) => {
  return (
    <ul>
      {map(menuItems, (menuItem) => {
        return (
          isEmpty(menuItem) ? <></> : <ChapterMenuItem
            key={get(menuItem, 'id') ? menuItem.id + uniqueId() : get(menuItem, 'value.id') + uniqueId()}
            menuItem={menuItem}
            toggleMenu={toggleMenu}
            level={level}
            type={type}
          />
        )
      })}
    </ul>
  )
}

export default ChapterMenu
